import { memo } from "react";
import { useSelector } from "react-redux";
import { GeoJSONLayer } from "react-mapbox-gl";

import { ROBOT_SUPPLIER } from "../../consts/filters/robotSupplier";

import {
  driverSelector,
  robotSuppliersSelector,
  routeInEditSelector,
} from "../../reducers/matrixProfile/selectors";
import { filterValueSelector } from "../../reducers/filters/selectors";

export const RobotSupplierRangeLayer = memo(() => {
  const robotSuppliers = useSelector(robotSuppliersSelector);
  const robotFilterSelectedValue = useSelector(
    filterValueSelector(ROBOT_SUPPLIER.field)
  );
  const routeEdit = useSelector(routeInEditSelector);
  const driver = useSelector(driverSelector(routeEdit?.driverCode));

  const robotSupplierCode =
    driver?.robotSupplierCode || robotFilterSelectedValue?.value;

  const { range } = robotSuppliers?.find(
    (supplier) => supplier.robotSupplierCode === robotSupplierCode
  ) || { range: null };

  return !!range ? (
    <GeoJSONLayer
      data={{
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: range,
        },
      }}
      fillPaint={{
        "fill-color": "#0091cd",
        "fill-opacity": 0.2,
      }}
      linePaint={{
        "line-color": "#000000",
        "line-opacity": 1,
        "line-width": 3,
        "line-dasharray": [2, 2],
      }}
    />
  ) : null;
});
